import { render, staticRenderFns } from "./act-list.vue?vue&type=template&id=5e09a2f0&scoped=true&"
import script from "./act-list.vue?vue&type=script&lang=js&"
export * from "./act-list.vue?vue&type=script&lang=js&"
import style0 from "./act-list.vue?vue&type=style&index=0&id=5e09a2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09a2f0",
  null
  
)

export default component.exports